import { createSlice } from '@reduxjs/toolkit';
import { authApi } from 'services/auth';

const initialState = {
  isLoggedIn: false,
  user: null,
  role: null,
  token: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateRole: (state, action) => {
      state.role = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.role = null;
      state.token = null;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
      const {
        data: { id, firstName, lastName, email, roleId, roleName, permissions, token }
      } = action.payload;
      state.user = {
        id,
        firstName,
        lastName,
        email
      };
      state.role = !roleId
        ? null
        : {
            id: roleId,
            name: roleName,
            permissions
          };
      state.isLoggedIn = true;
      state.token = token;
    });

    builder.addMatcher(authApi.endpoints.getRole.matchFulfilled, (state, action) => {
      const {
        data: { id, firstName, lastName, email, roleId, roleName, permissions, status }
      } = action.payload;

      if (status) {
        state.user = {
          id,
          firstName,
          lastName,
          email
        };
        state.role = !roleId
          ? null
          : {
              id: roleId,
              name: roleName,
              permissions
            };
      }
    });
  }
});

export const { updateRole, logout } = authSlice.actions;
export default authSlice.reducer;
